// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3mNRO","title":"InfoRow_title__24e-1"};